import React from "react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
const timelineData = [{
  year: "EST. 2010",
  title: "The Foundation",
  description: "AV Masonry began with a single trowel and a commitment to structural integrity. Based in Tavistock, we set out to redefine local construction standards through meticulous brickwork and a dedication to lasting quality.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1656752/img/masonry_foundation_bricks.png"
}, {
  year: "2020",
  title: "Precision Engineering",
  description: "Integrating advanced laser leveling and specialized mortar matching, we elevated our repair and restoration services. Our focus shifted toward preserving historic facades while ensuring modern durability.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1656752/img/precision_masonry_restoration.png",
  imageClassName: ""
}, {
  year: "PRESENT",
  title: "The AV Legacy",
  description: "Today, AV Masonry stands as a leader in Ontario's construction sector. We continue to build structures that stand the test of time, driven by the same passion for precision that started it all a decade ago.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1656752/img/av_masonry_legacy_project.png",
  imageClassName: ""
}];
export default function OnsVerhaal() {
  return <section data-section-id="224821" id="the-av-legacy" className="bg-background text-foreground py-32 px-4 md:px-8 relative overflow-hidden">
      <div className="max-w-7xl mx-auto">
        {}
        <div className="text-center mb-24">
          <span className="font-default text-sm font-bold text-primary mb-4 block tracking-widest uppercase">
            Decades of Precision
          </span>
          <div className="w-px h-12 bg-primary mx-auto mb-6" />
          <h2 className="font-default text-4xl md:text-5xl font-normal text-foreground mb-6 tracking-widest uppercase">
            The AV Legacy
          </h2>
          <p className="font-default text-muted-foreground max-w-2xl mx-auto text-lg leading-relaxed">
            From a humble start to Ontario's premier masonry specialists. 
            Explore the milestones that define our commitment to expert craftsmanship.
          </p>
        </div>

        {}
        <div className="relative">
          {}
          <div className="absolute left-6 md:left-1/2 top-0 bottom-0 w-px bg-border md:-translate-x-1/2" />

          {}
          <div className="space-y-24 md:space-y-32">
            {timelineData.map((item, i) => <div key={i} data-index={i} className={`${item.imageClassName || ""} relative flex flex-col md:flex-row items-center justify-between w-full ${i % 2 === 0 ? "md:flex-row-reverse" : ""}`}>
                {}
                <div className="absolute left-6 md:left-1/2 top-0 w-3 h-3 rounded-full bg-primary -translate-x-[5px] md:-translate-x-1/2 ring-4 ring-background mt-2 md:mt-0 z-10" />

                {}
                <div className="w-full pl-16 md:pl-0 md:w-[calc(50%-4rem)] flex flex-col justify-center">
                  <span className="font-default text-xl md:text-2xl font-bold text-primary mb-2 block uppercase tracking-wider">
                    {item.year}
                  </span>
                  <h3 className="font-default text-2xl md:text-3xl font-normal mb-4 uppercase tracking-wide">
                    {item.title}
                  </h3>
                  <p className="font-default text-muted-foreground leading-relaxed text-base md:text-lg">
                    {item.description}
                  </p>
                </div>

                {}
                <div className="w-full pl-16 md:pl-0 md:w-[calc(50%-4rem)] mt-8 md:mt-0">
                  <div className="relative rounded-none overflow-hidden border border-border/30 shadow-none group">
                    <div className={`${item.imageClassName || ""} absolute inset-0 ${i === 1 ? "" : "bg-primary/5 mix-blend-overlay"} z-10 transition-opacity duration-500 group-hover:opacity-0`} />
                    <AspectRatio ratio={4 / 3}>
                      <img src={item.image} alt={`${item.title} - ${item.year}`} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105 grayscale-[40%]" />
                    </AspectRatio>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}